import getMsg from './errorCode';
import BrowserUtils from '../../assets/utils/browser';
import { SafeEngineParams, SESealCtrlKeyType, keyType } from './keyModel';

class Ukey {
    init =  false;

    constructor(SafeEngineCtl, SESealCtrl) {
        try {
            if (BrowserUtils.isIE()) {
                this.ukey = SafeEngineCtl;
                this.setUkey = SESealCtrl;
                this.currentInstance = '';
            } else {
                console.log('init, ', window.shcaSecKit.getInstance);
                this.ukey = window.shcaSecKit.getInstance({
                    onSEBridgeWsError: function () {
                        new Error('服务启动失败');
                    }
                });
            }
        } catch (err) {
            console.log(err);
            throw new Error('初始化Ukey失败!');
        }
    }

    /**
     * 初始化服务
     *
     * @param {string} [str=""]
     * @returns
     * @memberof Ukey
     */
    initSm2Service (str = '', needPass = true) {
        let promise = new Promise(async (resolve, reject) => {
            if (BrowserUtils.isIE()) {
                let com = needPass ? SafeEngineParams.com1 : '';
                let deviceType = needPass ? SESealCtrlKeyType.WDC : SESealCtrlKeyType.NULL;
                // this.ukey.SEH_InitialSession(42, com, str, 0, 42, com, '');
                // console.log('initService rsa', this.ukey, this.ukey.ErrorCode);
                // console.log('start sm2 init', str);
                await this.clearSession();
                this.currentInstance = 'SM2';
                await this.ukey.ESE_InitialSession(deviceType, com, str, 0, deviceType, com, '');
                // console.log('initService sm2', this.ukey, this.ukey.ErrorCode);
                if (this.ukey.ErrorCode === 0) {
                    resolve({ code: 0, result: '环境初始化成功' });
                } else {
                    reject({ code: this.ukey.ErrorCode, message: getMsg(this.ukey.ErrorCode, true) });
                }
            }
        });
        return promise;
    }

    /**
     * 初始化服务
     *
     * @param {string} [str=""]
     * @returns
     * @memberof Ukey
     */
    initService (str = '', needPass = true) {
        let promise = new Promise(async (resolve, reject) => {
            if (BrowserUtils.isIE()) {
                console.log('initService, ', this.ukey);
                let com = needPass ? SafeEngineParams.com1 : '';
                let deviceType = needPass ? SESealCtrlKeyType.WDC : SESealCtrlKeyType.NULL;
                // console.log('start rsa init', str);
                await this.clearSession();
                this.currentInstance = 'RSA';
                await this.ukey.SEH_InitialSession(deviceType, com, str, 0, deviceType, com, '');

                console.log('initService end', this.ukey);

                if (this.ukey.ErrorCode === 0) {
                    this.init = true;
                    resolve({ code: 0, result: '环境初始化成功' });
                } else {
                    this.init = false;
                    reject({ code: this.ukey.ErrorCode, message: getMsg(this.ukey.ErrorCode, true) });
                }
            } else {
                console.log('initService, ', this.ukey);
                this.ukey.initService({
                    asymid: str,
                    res: data => {
                        if (data.ret === 0) {
                            this.init = true;
                            resolve({ code: 0, result: data });
                        } else {
                            this.init = false;
                            reject({ code: data.ret, message: getMsg(data.ret) });
                        }
                    }
                });
            }
        });
        return promise;
    }

    /**
     * 启动服务
     *
     * @param {string} [asymid=""]
     * @returns
     * @memberof Ukey
     */
    async startService (asymid = '') {
        let promise = new Promise((resolve, reject) => {
            this.initService(asymid)
                .then(data => {
                    let deviceConfigs = JSON.parse(data.result.str);
                    return this.setCryptoDevice(
                        (deviceConfigs && deviceConfigs[0]) || {}
                    );
                })
                .then(() => {
                    console.log('start success');
                    resolve({ code: 0, message: '启动成功!' });
                })
                .catch(err => {
                    console.log('start error');
                    reject(err);
                });
        });
        return promise;
    }

    /**
     * 关闭服务
     *
     * @returns
     * @memberof Ukey
     */
    closeService () {
        this.init = false;
        this.linked = false;
        this.ukey.closeService();
    }

    /**
     * 判断会否为法人一证通证书
     */
    isOneCertOfShecaSync (cert) {
        return this.ukey.isOneCertOfShecaSync({ cert });
    }

    /**
     * 获取UUID
     * @param {*} cert
     */
    getCertUniqueIDSync (cert) {
        return this.ukey.getCertUniqueIDSync({ cert });
    }

    /**
     * 当前插入的UKEY设备信息列表
     *
     * @param {string} [asymid='']
     * @returns
     * @memberof Ukey
     */
    listPlugin (asymid = '') {
        let promise = new Promise((resolve, reject) => {
            this.ukey.listPlugin({
                asymid,
                res: data => {
                    if (data.ret == 0) {
                        resolve({ code: 0, result: data.str });
                    } else {
                        reject({ code: data.ret, message: getMsg(data.ret) });
                    }
                }
            });
        });
        return promise;
    }

    /**
     * 设置当前UKEY设备(同步函数)
     *
     * @param {*} devType UKEY设备编号
     * @param {*} devParam UKEY设备参数
     * @param {*} asymid 密钥算法类型
     * @param {*} usage 密钥用途
     * @returns
     * @memberof Ukey
     */
    setCryptoDevice ({ devType, devParam, asymid, usage }) {
        let promise = new Promise((resolve, reject) => {
            try {
                this.ukey.setCryptoDevice({
                    devType,
                    devParam,
                    asymid,
                    usage
                });
                setTimeout(() => {
                    resolve({ code: 0, result: '成功' });
                }, 1000);
            } catch (err) {
                reject(err);
            }
        });
        return promise;
    }

    /**
     * 验证用户PIN码
     *
     * @param {*} pwd
     * @returns
     * @memberof Ukey
     */
    verifyUserPin (pwd) {
        let promise = new Promise(async (resolve, reject) => {
            if (BrowserUtils.isIE()) {
                let userPin = localStorage.getItem('UKEY_PASSWORD');
                if (pwd !== userPin) {
                    reject({
                        code: 111,
                        message: '密码错误，请检查后重新输入'
                    });
                } else {
                    resolve({ code: 0, result: '密码正确' });
                }
            } else {
                await this.ukey.verifyUserPin({
                    pwd,
                    res: data => {
                        if (data.ret == 0) {
                            resolve({ code: 0, result: data.str });
                        } else {
                            reject({
                                code: data.ret,
                                message: getMsg(data.ret)
                            });
                        }
                    }
                });
            }
        });
        return promise;
    }

    /**
     * 获取证书
     *
     * @param {string} [asymid=''] 秘钥类型
     * @param {string} [usage=''] 秘钥用途
     * @returns
     * @memberof Ukey
     */
    getCert (asymid = '', usage = '') {
        let promise = new Promise((resolve, reject) => {
            if (BrowserUtils.isIE()) {
                let strCert;
                if (this.currentInstance === 'RSA') {
                    strCert = this.ukey.SEH_GetSelfCertificate(SESealCtrlKeyType.WDC, SafeEngineParams.com1, "");
                } else if (this.currentInstance === 'SM2'){
                    strCert = this.ukey.ESE_GetSelfCertificate(SESealCtrlKeyType.WDC, SafeEngineParams.com1);
                }
                if (this.ukey.ErrorCode === 0) {
                    resolve({ code: 0, result: strCert });
                } else {
                    reject({ code: this.ukey.ErrorCode, message: getMsg(this.ukey.ErrorCode, true) });
                }
            } else {
                this.ukey.getCert({
                    asymid,
                    usage,
                    res: data => {
                        if (data.ret == 0) {
                            resolve({ code: 0, result: data.str });
                        } else {
                            reject({ code: data.ret, message: getMsg(data.ret) });
                        }
                    }
                });
            }
        });
        return promise;
    }

    /**
     * 获取设备序列号
     *
     * @returns
     * @memberof Ukey
     */
    getKeySN () {
        let promise = new Promise((resolve, reject) => {
            this.ukey.getKeySN({
                res: function (data) {
                    if (data.ret == 0) {
                        resolve({ code: 0, result: data.str });
                    } else {
                        reject({ code: data.ret, message: getMsg(data.ret) });
                    }
                }
            });
        });
        return promise;
    }

    /**
     * 同步方式获取证书细目
     *
     * @param {*} cert
     * @param {*} itemNo
     * @returns
     * @memberof Ukey
     */
    getCertDetailSync (cert, itemNo) {
        if (BrowserUtils.isIE()) {
            return this.ukey.SEH_GetCertDetail(cert, itemNo);
        } else {
            return this.ukey.getCertDetailSync({ cert, itemNo });
        }
    }

    /**
     * 验证用户证书有效性
     *
     * @param {*} cert
     * @param {*} cfg 验证类型,缺省值:0 0:不验证CRL,1000:验证OCSP,其他:验证CRL
     * @returns
     * @memberof Ukey
     */
    verifyCertificate (cert, cfg) {
        let promise = new Promise((resolve, reject) => {
            if (BrowserUtils.isIE()) {
                this.ukey.SEH_VerifyCertificateOnline(cert);
                if (this.ukey.ErrorCode === 0) {
                    resolve({ code: 0, message: '证书有效!' });
                } else {
                    reject({ code: this.ukey.ErrorCode, message: getMsg(this.ukey.ErrorCode, true) });
                }
            } else {
                this.ukey.verifyCertificate({
                    cert,
                    cfg,
                    res: function (data) {
                        if (data.ret == 0) {
                            resolve({ code: 0, message: '证书有效!' });
                        } else {
                            reject({ code: data.ret, message: getMsg(data.ret) });
                        }
                    }
                });
            }
        });
        return promise;
    }

    /**
     * 获取印章内容
     *
     * @param {*} type 1:印章结构 2:印章图片 3:签发者证书
     * @returns
     * @memberof Ukey
     */
    getSeal (type) {
        let promise = new Promise((resolve, reject) => {
            if (BrowserUtils.isIE()) {
                let base64Str = this.ukey.SEH_GetSealInfo(SESealCtrlKeyType.WDC, SafeEngineParams.com1, type);
                if (this.ukey.ErrorCode === 0) {
                    resolve({ code: 0, result: base64Str });
                } else {
                    reject({ code: this.ukey.ErrorCode, message: getMsg(this.ukey.ErrorCode, true) });
                }
            } else {
                this.ukey.getSeal({
                    type,
                    res: function (data) {
                        if (data.ret == 0) {
                            resolve({ code: 0, result: data.str });
                        } else {
                            reject({ code: data.ret, message: getMsg(data.ret) });
                        }
                    }
                });
            }
        });
        return promise;
    }

    /**
     * 设置印章信息
     *
     * @param {*} { pwd, struct, pic, issuer }
     * @returns
     * @memberof Ukey
     */
    setSeal ({ pwd, struct, pic, issuer }) {
        let promise = new Promise((resolve, reject) => {
            if (BrowserUtils.isIE()) {
                let result = this.setUkey.SaveSeal(SESealCtrlKeyType.WDC, SafeEngineParams.com1, pwd, struct, pic, issuer);
                if (result == 0) {
                    resolve({ code: 0, result: '写入成功' });
                } else {
                    reject({ code: result, message: getMsg(result, true) });
                }
            } else {
                this.ukey.setSeal({
                    pwd,
                    struct,
                    pic,
                    issuer,
                    res: function (data) {
                        if (data.ret == 0) {
                            resolve({ code: 0, result: data.str });
                        } else {
                            reject({ code: data.ret, message: getMsg(data.ret) });
                        }
                    }
                });
            }
        });
        return promise;
    }

    /**
     * 数字签名
     *
     * @param {*} data 待签名数据(大小不要超过24K字节)
     * @param {*} pwd  用户PIN码
     * @param {*} isHex 是否是二进制数据(BASE64)，缺省:false
     * @param {*} asymid 签章类型
     * @param {*} algid 签名算法标识ID,缺省:3 3:SHA1withRSA算法 4:SHA256withRSA算法 5:SHA384withRSA算法 6:SHA512withRSA算法
     * @returns
     * @memberof Ukey
     */
    sign ({ data, pwd, asymid, algid = 4, isHex = false }) {
        let promise = new Promise((resolve, reject) => {
            if (BrowserUtils.isIE()) {
                let signData;
                let uekyInstance;
                // console.log('开始sign 方法，asymid=', asymid);
                if (asymid === keyType.K_SHCA_ASYMID_SM2) {
                    // sm2 签名
                    uekyInstance = this.ukey;
                    console.log('sm2 uekyInstance', uekyInstance, uekyInstance.SEH_SignHex);
                    // signData = uekyInstance.ESE_SignData(data, '');
                    if (isHex) {
                        signData = uekyInstance.ESE_SignHex(data, '');
                    } else {
                        signData = uekyInstance.ESE_SignData(data, '');
                    }
                } else {
                    // rsa 签名
                    uekyInstance = this.ukey;
                    // console.log('rsa uekyInstance', uekyInstance, uekyInstance.SEH_SignHex);
                    if (isHex) {
                        signData = uekyInstance.SEH_SignHex(data, algid);
                    } else {
                        signData = uekyInstance.SEH_SignData(data, algid);
                    }
                }
                // console.log(`sign 方法结束, signData=${signData}；可能的错误${uekyInstance.ErrorCode}`);
                if (uekyInstance.ErrorCode === 0) {
                    resolve({ code: 0, result: signData });
                } else {
                    reject({ code: uekyInstance.ErrorCode, message: getMsg(uekyInstance.ErrorCode, true) });
                }
            } else {
                this.ukey.sign({
                    data,
                    pwd,
                    asymid,
                    isHex,
                    algid,
                    res: data => {
                        if (data.ret == 0) {
                            resolve({ code: 0, result: data.str });
                        } else {
                            reject({ code: data.ret, message: getMsg(data.ret) });
                        }
                    }
                });
            }
        });
        return promise;
    }

    signByRsa(data, pwd) {
        return this.sign({data, pwd, asymid: keyType.K_SHCA_ASYMID_RSA});
    }

    signBySm2(data, pwd) {
        return this.sign({data, pwd, asymid: keyType.K_SHCA_ASYMID_SM2});
    }

    /**
     * 对HASH值进行数字签名
     *
     * @param {*} data
     * @param {*} pwd
     * @param {*} algid 签名算法标识ID,缺省:3 3:SHA1withRSA算法 4:SHA256withRSA算法 5:SHA384withRSA算法 6:SHA512withRSA算法
     * @memberof Ukey
     */
    signHash ({ data, pwd, algid = 4 }) {
        let promise = new Promise((resolve, reject) => {
            this.ukey.signHash({
                data,
                pwd,
                algid,
                res: data => {
                    if (data.ret == 0) {
                        resolve({ code: 0, result: data.str });
                    } else {
                        reject({ code: data.ret, message: getMsg(data.ret) });
                    }
                }
            });
        });
        return promise;
    }

    /**
     * 数字签名
     *
     * @param {*} data 待签名数据,验证SM2签名时不需要
     * @param {*} cert 用户证书,验证SM2签名时不需要
     * @param {*} signdata  签名值(BASE64)
     * @param {*} isHex 是否是二进制数据(BASE64)，缺省:false
     * @param {*} algid 签名算法标识ID,缺省:3 3:SHA1withRSA算法 4:SHA256withRSA算法 5:SHA384withRSA算法 6:SHA512withRSA算法
     * @returns
     * @memberof Ukey
     */
    verifySign ({ data, cert, signdata, isHex = false, algid = 4 }) {
        let promise = new Promise((resolve, reject) => {
            this.ukey.verifySign({
                data,
                cert,
                signdata,
                isHex,
                algid,
                res: function (data) {
                    if (data.ret == 0) {
                        resolve({ code: 0, result: '证书有效!' });
                    } else {
                        reject({ code: data.ret, message: getMsg(data.ret) });
                    }
                }
            });
        });
        return promise;
    }

    async clearSession () {
        const promise = new Promise(async (resolve, reject) => {
            try {
                if (this.currentInstance === 'SM2') {
                    // console.log('clear sm2 session');
                    this.ukey.ESE_ClearSession && (await this.ukey.ESE_ClearSession());
                    this.currentInstance = '';
                } else if (this.currentInstance === 'RSA') {
                    // console.log('clear rsa session');
                    this.ukey.SEH_ClearSession && (await this.ukey.SEH_ClearSession());
                    this.currentInstance = '';
                } else {
                    // console.log('no need clear session');
                }
                resolve();
            } catch (e) {
                console.log('clearSession error', e);
                reject();
            }
        });
        return promise;
    }
}

export default Ukey;
